import { lazy } from 'react'

export const DeterminedV1 = lazy(() => import('./v1/DeterminedV1'))
